console.log('karuizawa');

const mySwiper = new Swiper('.swiper', {
    loop: true,
    speed: 10000,
    allowTouchMove: false,
    slidesPerView: 2.5,
    spaceBetween: '3%',
    autoplay: {
        delay: 0,
    },
    breakpoints: {
        769: {
            slidesPerView: 3.5,
            spaceBetween: 50,
        }
    }
});